import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BotService } from './bot.service';
import { BotidService } from '@shared-angular/services/ragai/botid.service';



@Injectable({
  providedIn: 'root'
})
export class DownloadManagerService {
  constructor(
    private botService: BotService,
    private botIdService: BotidService,
    private http: HttpClient
  ) { }

  private download(file: Blob, filename: string) {
    const fileURL = URL.createObjectURL(file);
    const element = document.createElement('a');
    element.setAttribute('href', fileURL);
    element.setAttribute('download', filename);
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
    URL.revokeObjectURL(fileURL);
  }

  public textAsFile(text: string, filename: string) {
    const blob = new Blob([text], { type: 'text/plain' });
    this.download(blob, filename);
  }

  public async downloadMaterial(skillId: string) {
    const docInfo = await this.botService.getFileInformation(this.botIdService.getBotId(), skillId);
    const docContent = await this.botService.getDownloadableMaterial(this.botIdService.getBotId(), docInfo.id);
    const blob = new Blob([docContent], { type: docInfo.type });
    this.download(blob, docInfo.name);
  }

  public async getMDContent(skillId: string): Promise<{ id: string, name: string, type: string, content: string }> {
    return await this.botService.getMDFile(this.botIdService.getBotId(), skillId);
  }

  public async downloadFilledPDFTemplate(skillId: string, filename: string) {
    const res = await firstValueFrom(this.http.get("/api/user/docdownload/" + this.botIdService.getBotId() + "/filledtemplate/" + skillId + "/" + filename, { responseType: "blob" }));
    this.download(res, filename);
  }
}
